import {
   getAdCopiesLoading,
   getAdCopiesSuccess,
   getAdCopiesFailure,
   updateAdCopyLoading,
   updateAdCopySuccess,
   updateAdCopyFailure,
} from "@redux/slices/adCopiesSlice.js"
import { getAdCopies } from "@services/adCopies/getAdCopies"
import { updateAdCopy } from "@services/adCopies/updateAdCopy"
import { useDispatch } from "react-redux"

const useAdCopies = () => {
   const dispatch = useDispatch()

   const handleGetAdCopies = async (userId) => {
      try {
         dispatch(getAdCopiesLoading())
         const response = await getAdCopies(userId)
         dispatch(getAdCopiesSuccess(response.data.data))
      } catch (error) {
         dispatch(getAdCopiesFailure())
         console.log(error)
      }
   }

   const handleUpdateAdCopy = async (updateData) => {
      try {
         dispatch(updateAdCopyLoading())
         const response = await updateAdCopy(updateData)
         dispatch(updateAdCopySuccess(response.data))
         return response.data
      } catch (error) {
         dispatch(updateAdCopyFailure())
         console.log(error)
         throw error
      }
   }

   return { handleGetAdCopies, handleUpdateAdCopy }
}

export default useAdCopies
